import { defaultConfig } from 'app/config/environment';
import axios from 'axios';
import { getContentCms } from 'core/crud/contents.crud';
import { useUser } from 'core/lite/hooks/useUser';
import { successResponse } from 'core/utils/utils';

export function useXapi() {
  const { authToken, isTeacher } = useUser();

  async function onGetUrlXapi(contentGuid) {
    const response = await getContentCms(contentGuid);
    if (successResponse(response)) {
      const data = response.data.data;
      if (data.url) {
        let query = data.xapi?.query;
        let parsedUrl = data.url.startsWith('https://') ? data.url : defaultConfig.BASE_URL_ + data.url.substring(1);
        const storageResponse = await axios.get(parsedUrl, {
          headers: {
            Authorization: authToken,
          },
          maxRedirects: 0,
        });
        if (successResponse(storageResponse)) {
          let storageUrl = storageResponse.data.data.url;
          console.log('storageUrl', storageUrl);
          let responseCookies = storageResponse.data.data.cookies;
          responseCookies.forEach((cookie) => {
            document.cookie = cookie;
          });
          let xapiUrl = storageUrl.replace('index_prof.html', query);
          xapiUrl = xapiUrl.replace('index_alu.html', query);
          if (isTeacher) xapiUrl = xapiUrl.replace('index_alu.html', 'index_prof.html');
          console.log('xapiUrl', xapiUrl);
          return xapiUrl;
        }
      } else return null;
    }

    return null;
  }

  return { onGetUrlXapi };
}
